export const COUNTRIES = [
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
  { value: "GB", label: "United Kingdom" },
  { value: "AU", label: "Australia" },
  { value: "DE", label: "Germany" },
  { value: "FR", label: "France" },
  { value: "ES", label: "Spain" },
  { value: "IT", label: "Italy" },
  { value: "NL", label: "Netherlands" },
  { value: "BE", label: "Belgium" },
  { value: "CH", label: "Switzerland" },
  { value: "AT", label: "Austria" },
  { value: "SE", label: "Sweden" },
  { value: "NO", label: "Norway" },
  { value: "DK", label: "Denmark" },
  { value: "FI", label: "Finland" },
  { value: "IE", label: "Ireland" },
  { value: "NZ", label: "New Zealand" },
  { value: "JP", label: "Japan" },
  { value: "KR", label: "South Korea" },
  { value: "SG", label: "Singapore" },
  { value: "HK", label: "Hong Kong" },
  { value: "TW", label: "Taiwan" },
  { value: "MX", label: "Mexico" },
  { value: "BR", label: "Brazil" },
  { value: "AR", label: "Argentina" },
  { value: "CL", label: "Chile" },
  { value: "CO", label: "Colombia" },
  { value: "IN", label: "India" },
  { value: "IL", label: "Israel" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "ZA", label: "South Africa" },
  { value: "OTHER", label: "Other" },
] as const;
export type CountryCode = (typeof COUNTRIES)[number]["value"];

export const LANGUAGES = [
  { value: "es", label: "Spanish" },
  { value: "zh", label: "Chinese (Mandarin)" },
  { value: "zh-yue", label: "Chinese (Cantonese)" },
  { value: "vi", label: "Vietnamese" },
  { value: "ko", label: "Korean" },
  { value: "tl", label: "Tagalog" },
  { value: "ru", label: "Russian" },
  { value: "ar", label: "Arabic" },
  { value: "pt", label: "Portuguese" },
  { value: "fr", label: "French" },
  { value: "de", label: "German" },
  { value: "ja", label: "Japanese" },
  { value: "hi", label: "Hindi" },
  { value: "fa", label: "Farsi (Persian)" },
  { value: "pl", label: "Polish" },
  { value: "it", label: "Italian" },
  { value: "ur", label: "Urdu" },
  { value: "pa", label: "Punjabi" },
  { value: "bn", label: "Bengali" },
  { value: "ht", label: "Haitian Creole" },
  { value: "OTHER", label: "Other" },
] as const;
export type LanguageCode = (typeof LANGUAGES)[number]["value"];

export const VALID_REASON_OPTIONS = [
  "signatera",
  "altera",
  "latitude",
  "empower",
] as const;
export type ReasonOption = (typeof VALID_REASON_OPTIONS)[number];

// Aliases for test types that are not yet supported by the GIS intake form.
const TEST_TYPE_ALIASES: Record<string, ReasonOption> = {
  dpyd: "signatera",
};

/**
 * Maps SOS / GraphQL test type strings (e.g. SIGNATERA, SIGNATERA_FOLLOW_UP, DPYD) to
 * GIS "reason for appointment" checkbox values.
 */
export function testTypeToReasonOption(
  testType: string | undefined | null
): ReasonOption | null {
  if (!testType) return null;
  const t = testType.toLowerCase();
  if ((VALID_REASON_OPTIONS as readonly string[]).includes(t as ReasonOption)) {
    return t as ReasonOption;
  }
  if (t in TEST_TYPE_ALIASES) {
    return TEST_TYPE_ALIASES[t];
  }
  for (const opt of VALID_REASON_OPTIONS) {
    if (t.includes(opt)) return opt;
  }
  return null;
}

export const VALID_UNDERSTANDING_OPTIONS = [
  "easy",
  "hard",
  "very_hard",
] as const;
export type UnderstandingOption = (typeof VALID_UNDERSTANDING_OPTIONS)[number];
